import { render, staticRenderFns } from "./Webhook-Setting.vue?vue&type=template&id=12682ea2&scoped=true"
import script from "./Webhook-Setting.vue?vue&type=script&lang=js"
export * from "./Webhook-Setting.vue?vue&type=script&lang=js"
import style0 from "./Webhook-Setting.vue?vue&type=style&index=0&id=12682ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12682ea2",
  null
  
)

export default component.exports